module.exports = __webpack_public_path__ + "static/media/authorization-service.9f04338a.png";